/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IdentityRequest
 */
export interface IdentityRequest {
    /**
     * 
     * @type {string}
     * @memberof IdentityRequest
     */
    authenticationToken: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityRequest
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof IdentityRequest
     */
    lastName: string;
}

/**
 * Check if a given object implements the IdentityRequest interface.
 */
export function instanceOfIdentityRequest(value: object): value is IdentityRequest {
    if (!('authenticationToken' in value) || value['authenticationToken'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function IdentityRequestFromJSON(json: any): IdentityRequest {
    return IdentityRequestFromJSONTyped(json, false);
}

export function IdentityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'authenticationToken': json['authenticationToken'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
    };
}

export function IdentityRequestToJSON(value?: IdentityRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'authenticationToken': value['authenticationToken'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
    };
}

